import { render, staticRenderFns } from "./ErrorNotice.vue?vue&type=template&id=03ac79c2&"
import script from "./ErrorNotice.vue?vue&type=script&lang=js&"
export * from "./ErrorNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports